import React, { useState, useContext, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";

//Images
import pattern6 from './../../../images/pattern/pattern6.png';
import circle from './../../../images/pattern/circle.png';
//Components
import { ThemeContext } from "../../../context/ThemeContext";

import PreviousTab from '../Dompet/Home/PreviousTab';
import PoInvoiceCard from '../Dompet/Home/PoInvoiceCard';

import AdminServices from '../../../services/AdminServices';


const Home1 = () => {
	const[data,setData]=useState()
	useEffect(() => {
  const fetchPOData = async () => {
    try {
      const res = await AdminServices.dashboardPO();
      const result = res?.data; // ✅ Access actual data

      if (!result || Object.keys(result).length === 0) {
        Swal.fire({
          icon: 'info',
          title: 'No Records Found',
          text: 'There is no data available to show.',
        });
        setData(null); // or setData({})
      } else {
        setData(result);
        console.log('PO Dashboard Data:', result);
      }
    } catch (error) {
      console.error('Error fetching PO Dashboard data:', error);
      Swal.fire({
        icon: 'error',
        title: 'Failed to Load Data',
        text: 'Something went wrong while fetching the dashboard data.',
      });
    }
  };

  fetchPOData();
}, []);


console.log("home1....")
	return (
		<>
			<div className="row invoice-card-row">
				<PoInvoiceCard data={data}/>
			</div>
		</>
	)
}
export default Home1;